import { Controller as StimulusController } from '@hotwired/stimulus'

export default class TurboModalController extends StimulusController {
  static values = {
    explicitClose: { type: Boolean, default: false }
  }

  connect() {
    super.connect()
    this.onLoad()
    if (this.explicitCloseValue) {
      this.requireExplicitClose()
    }
  }

  onLoad() {
    // To get opening animations, invoke the open method later in the JS event cycle
    setTimeout(() => this.open(), 1)
  }

  open() {
    this.element.show()
  }

  close() {
    this.element.hide()
  }

  afterHide() {
    // Clear the contents of the turbo-frame when the modal is hidden
    this.element.parentElement.replaceChildren()
  }

  requireExplicitClose(){
    /**
     * Optionally prevent the modal from being closed when ESC is pressed, or when the user clicks on the overlay
     */
    this.element.addEventListener('sl-request-close', (event) => {
      const escKeyPressed = event.detail.source === 'keyboard'
      const overlayClicked = event.detail.source === 'overlay'

      if (escKeyPressed || overlayClicked) {
        event.preventDefault()
      }
    })
  }
}
